export default __webpack_public_path__ + "static/media/upee_with_a.85f55320.webp";